import React from "react";
import PropTypes from "prop-types";
import { compose } from 'redux'
import { connect } from 'react-redux'
import ReactChartkick, { PieChart } from 'react-chartkick'
import Chart from 'chart.js'
import {Button as FabButton} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditIcon from '@material-ui/icons/Edit';
import NavigateBefore from '@material-ui/icons/NavigateBefore';
import NavigateNext from '@material-ui/icons/NavigateNext';
import InfoIcon from '@material-ui/icons/Info';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import _ from 'lodash';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import {firestoreConnect,isEmpty, isLoaded} from 'react-redux-firebase'
import Geocode from "react-geocode";
import { withStyles,
    Paper,
    Input,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    TextField,
    AppBar,
    Tabs,
    Tab,
    Card,
    Typography,
    InputAdornment,
    Badge,
    Chip,
    Tooltip,
    Dialog,DialogActions,DialogContent,DialogContentText,DialogTitle, Button as MaterialButton
}  from "@material-ui/core";

import {CustomInput,TextQuestion,ImageQuestion,Button,LoadingSpinner,MultipleChoiceQuestion,CheckBoxChoiceQuestion,ExportButton} from "../../components"

ReactChartkick.addAdapter(Chart)
Geocode.setApiKey("AIzaSyDIrSa_1_tiXDqMguTAr4g9sp6W5Il7G5U");
var surveyId;

function TabContainer(props) {
    return (
      <Typography component="div" style={{ padding: 8 * 3 }}>
        {props.children}
      </Typography>
    );
  }
  
  TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
  };
  

class ViewSurvey extends React.Component {

        constructor(props){
            super(props)
            surveyId = this.props.route.match.params.id 
            this.updateWindowDimensions = this.updateWindowDimensions.bind(this);        
        }


        componentDidMount() {
            this.updateWindowDimensions();
            window.addEventListener('resize', this.updateWindowDimensions);
          }
          
          componentWillUnmount() {
            window.removeEventListener('resize', this.updateWindowDimensions);
          }
          
          updateWindowDimensions() {
            this.setState({ width: window.innerWidth, height: window.innerHeight });
          }

        state={
            dialogOpen:false,
            isLoading:false,
            isPublishing:false,
            value: 0,
            responseValue: 0,
            isActive: this.props.survey? this.props.survey.isActive:"",
            width: 0,
             height: 0,
            currentUserAnswerIndex:0,
            previousUserAnswerIndex:null,
            address:null,
            address1:null,
            gotAddress:true,
        }


        publish =()=>{
            const {firestore,survey} = this.props
            this.setState({isPublishing:true})
            firestore.update({collection:"surveys",doc:surveyId},{
                isActive:true
            }).then(()=>{
                this.setState({isPublishing:false})
                this.setState({isActive:true})
            })

        }

        editSurvey=()=>{
            const {history} = this.props
            history.push(`/survey/${surveyId}/edit`)
        }

        unpublish=()=>{
            const {firestore,survey} = this.props
            this.setState({isPublishing:true})
            firestore.update({collection:"surveys",doc:surveyId},{
                isActive:false
            }).then(()=>{
                this.setState({isPublishing:false})
                this.setState({isActive:false})
            })
        }
        deleteEmptySurvey=()=>{
            const {firestore,survey,history,userAnswers,questions} = this.props
            if(userAnswers && userAnswers.length == 0 ){
                if(questions){
                    _.map(questions,(question,key)=>{
                        if(question){
                         firestore.delete({collection:"surveys",doc:surveyId, subcollections: [{ collection: 'questions', doc: key }]})
                        }
                    })
                }
             firestore.delete({collection:"surveys",doc:surveyId})
             this.setState({isLoading:false})
             this.setState({dialogOpen:false})
             history.push(`/survey`)
            }
        }

        openDeleteModal = () => {
            this.setState({ dialogOpen: true });
        };
    
        handleClose = () => {
            this.setState({ dialogOpen: false });
        };
    

        handleChange = (event, value) => {
            this.setState({ value });
          };

          handleResponseChange = (event, value) => {
            this.setState({ responseValue:value });
          };


        render(){
            const {isPublishing,value} = this.state
            const {survey,classes,userAnswers} = this.props

            
            return(
                <div className={classes.root}>
                    {isLoaded(survey)&&isLoaded(userAnswers)?               
                            <Paper className={classes.paperContainer}>
                            <div className={classes.surveyContainer}>
                            <div className={classes.surveyHeaderBar}>
                                <h6 style={{paddingLeft:20}}>{survey&&this.state.isActive?<Chip label="Active" style={{backgroundColor:"#4CAF50",color:"#fff"}}></Chip>:<Chip label="Inactive" style={{backgroundColor:"#FF9900",color:"#fff"}}></Chip>}</h6>
                                    <div>
                                    {!isPublishing && userAnswers && userAnswers.length == 0 ?
                                        <Tooltip title="Delete Survey" placement="bottom"  classes={{ tooltip: classes.lightTooltip }}>
                                            <DeleteIcon style={{paddingTop: 15,marginRight:20,color:"rgba(0, 0, 0, 0.4)",cursor: "pointer",float:"right"}} onClick={this.openDeleteModal}>Delete</DeleteIcon>
                                        </Tooltip>
                                    :<div/>}
                                    {isPublishing?
                                        <div style={{marginRight:25}} ><LoadingSpinner/></div>:
                                            survey&&this.state.isActive?
                                                <Button style={{marginRight:30,backgroundColor:"#FF9900"}} color="warning" onClick={this.unpublish}>Unpublish</Button>:
                                                <Button style={{marginRight:30}} color="success" onClick={this.publish}>Publish</Button>

                                    }
                                    </div>
                            </div>
                            <div className={""}>
                            <AppBar style={{boxShadow:"none",backgroundColor:"#fff",width:"inherit"}} position="static">
                            <div style={{alignItems:"center",justifyContent:"center",marginLeft:"62%",marginTop:"2%"}}>
                            </div>
                            <Tabs 
                                value={value}
                                onChange={this.handleChange}
                                indicatorColor="primary"
                                textColor="primary"
                                centered
                                >       
                                <Tab style={{fontSize:20,fontWeight:700}} label="QUESTIONS" />
                                <Tab style={{fontSize:20,fontWeight:700}}  label={
                                <Badge style={{padding:8,margin:8}} color="primary" badgeContent={userAnswers?userAnswers.length:0}>
                                    RESPONSES
                                </Badge>
                                } />
                            </Tabs>
                            </AppBar>
                            {value === 0 && <TabContainer>{this.renderQuestions()}</TabContainer>}
                            {value === 1 && <TabContainer>{this.renderResponses()}</TabContainer>}
                        </div>
                            </div>

                        </Paper>
                        :null
                    }
                    <FabButton variant="fab" className={classes.fab} color="primary" onClick={this.editSurvey}>
                        <EditIcon/>
                    </FabButton>

                    <Dialog
                    open={this.state.dialogOpen}
                    onClose={this.handleClose}
                    aria-labelledby="delete-dialog-title"
                >
                    <DialogTitle id="delete-dialog-title">Delete Campaign</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this campaign.
                        </DialogContentText>
    
                    </DialogContent>
                    <DialogActions>
                        <MaterialButton onClick={this.handleClose} color="primary">
                            Cancel
                        </MaterialButton>
                            <MaterialButton onClick={this.deleteEmptySurvey} color="primary">
                                {!this.state.isLoading ? "Delete": <LoadingSpinner/>}
                            </MaterialButton>:
                    </DialogActions>
                </Dialog>
                </div>

            )

        }

        renderResponses = () => {
            const {responseValue,width} = this.state
            const {survey,classes,userAnswers} = this.props;

            return(
             <div className={classes.root}>
               {!isEmpty(userAnswers)?
                <div style={{width:"100%"}}>
                    <h6 style={{width:"100%",color:"#fc824e",fontSize:25,margin:0,marginLeft:28,marginBottom:28}}>Campaign Feedback</h6>
                    <AppBar style={{backgroundColor:"#ededed", width: 320,marginLeft:28,backgroundColor:"#ededed"}} position="static">
                            <Tabs 
                                value={responseValue}
                                onChange={this.handleResponseChange}
                                indicatorColor="primary"
                                textColor="secondary"
                                >       
                                <Tab style={{fontSize:14,fontWeight:600}} label="INDIVIDUAL" />
                                <Tab style={{fontSize:14,fontWeight:600}}  label="SUMMARY" />
                            </Tabs>
                    </AppBar>
                        {responseValue === 0 && 
                        <TabContainer>{this.renderIndividualResponses()}</TabContainer>
                        }
                        {responseValue === 1 && <TabContainer>{this.renderSummaryResponses()}</TabContainer>}
                </div>
               :
               <div style={{width:"70%",alignItems:"center",justifyContent:"center",marginLeft:"5%"}} >
                        <Card style={{width:"100%",alignItems:"center",justifyContent:"center"}}>
                            <h6 style={{textAlign:"center",color:"#FF9900"}}><InfoIcon style={{marginBottom:-19,marginRight:10,fontSize:47}}/>No user Responses are currently available</h6>
                            <p style={{textAlign:"center",marginBottom:40,color:"rgb(168, 168, 168)"}}>
                                Please wait for users to complete the campaign.</p>
                        </Card>    
                </div> 
               }

            </div>
            )
        }

        renderSummaryResponses = () => {
            return(
            <div style={{marginTop:"2%"}} >
                {this.responseList()}
             </div> 
            )
        }

        responseList = () => {  
            const {responseValue,width} = this.state
            const {survey,classes,userAnswers} = this.props;
            var questionItems = [];
            var Answers = Object.values(Object.values(userAnswers&&userAnswers.length>0?userAnswers:[]))
            var questions = Object.values(Answers[0].questions);
            var questionKeys = Object.keys(Answers[0].questions);

            for(var j = 0 ;j < Answers.length; j++ ){
                var isAdded = false
                for(var i = 0 ;i < questions.length; i++ ){
                    for(var k = 0 ;k < Object.values(Answers[j].questions).length; k++ ){
                       
                        if( Object.values(Answers[j].questions)[k].prompt == questions[i].prompt){
                            isAdded = true
                        }

                    }
                }
                if(!isAdded){
                    questions.push.apply(questions,Object.values(Answers[j].questions))
                    questions.push.apply(questionKeys,Object.keys(Answers[j].questions))              
                }             
            }

            for(var i = 0 ;i < questions.length; i++ ){
                questions[i]["id"] = questionKeys[i]
            }




            questionItems = Object.values(questions).map((question,index) =>{
                    var data = [];
                    var textData = [];
                    var options = question.options         
                    if(options){
                        for(var i = 0 ;i < options.length; i++ ){
                            var currentNumberOfAnwsers = 0
                            for(var currentAnswersIndex = 0 ;currentAnswersIndex < Answers.length ; currentAnswersIndex++ ){
                               
                                var currentAnswers = Object.values(Answers[currentAnswersIndex].answers)
                                var currentAnswersIds = Object.keys(Answers[currentAnswersIndex].answers)
                           
            
                                for(var j = 0 ;j < currentAnswers.length; j++ ){                          
                                    if( currentAnswers[j].includes(options[i]) && question.id == currentAnswersIds[j]){
                                                currentNumberOfAnwsers++;
                                    }
                                }
                            } 

                        data.push([options[i],(currentNumberOfAnwsers).toFixed(2)]);
                            
                        }
                    }
                    //its a text question
                    else{
                        for(var currentAnswersIndex = 0 ;currentAnswersIndex < Answers.length ; currentAnswersIndex++ ){
                            var currentAnswers = Object.values(Answers[currentAnswersIndex].answers)
                            var currentQuestions = Object.values(Answers[currentAnswersIndex].questions)
                            console.log(currentQuestions)
                            var isHere = false;
                            for(var i = 0 ;i < currentQuestions.length; i++ ){                                        
                                if(question.prompt == currentQuestions[i].prompt){
                                    isHere = true;
                                }                           
                            }
                            if(isHere){
                                textData.push([currentAnswers[index]]);
                            }

                           
                        }

                    }


                    var totalData = 0;
                    for(var i = 0 ;i < data.length; i++ ){
                        console.log(data[i][1])
                        totalData = parseFloat(totalData) +  parseFloat(data[i][1])                     
                    }
                    for(var i = 0 ;i < data.length; i++ ){
                       data[i][1] = ((parseFloat(data[i][1])/totalData)*100).toFixed(2)                                       
                    }

                    return(
                    <ExpansionPanel className={classes.questionPanel}  key={index}>
                        <ExpansionPanelSummary className={classes.questionPanelSummary} expandIcon={<ExpandMoreIcon />}>
                                <h4 style={{color:"rgba(0, 0, 0, 0.54)",fontSize:14}}>Question {index+1} : {question.prompt} </h4> 
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                            {
                            options?
                                <PieChart  suffix="%" data={data} />
                            :
                            <div className={classes.root}>
                                <List component="nav">
                                { textData.map((item,index) => (
                                    question.type == "image" ?
                                    <ListItem style={{paddingTop:3,paddingBottom:3}} key={`item-${index}-${item}`}>
                                    <ListItemText>
                                        <span style={{fontSize:14}}>{index+1}.&nbsp;</span>
                                        <img style={{width:"40%",height:"40%"}} src={item} width="50%"></img>
                                    </ListItemText>
                                    </ListItem>
                                    :
                                    <ListItem style={{paddingTop:3,paddingBottom:3}} key={`item-${index}-${item}`}>
                                      <ListItemText><span style={{fontSize:14}}>{index+1}. {item}</span></ListItemText>
                                    </ListItem>
                                  ))}
                                </List>
                            </div>
                            }
                            </ExpansionPanelDetails>
                    </ExpansionPanel>     
                    )  
                }

            );
            return(
             <div>
                 <div  style={{width:"100%",color:"#fc824e",fontSize:20,marginBottom:35}}>Summary of all campaigns</div>
                    <div>
                        <ExportButton 
                        data={this.getAllExportData}
                        candidate={"summary"}
                        surveyName={survey.name}
                        />
                    </div> 
                 <div>{questionItems}</div>
             </div> 
            )

        }

        nextUserAnswer = () =>{
            const {currentUserAnswerIndex} = this.state
            const {userAnswers} = this.props;

            if(currentUserAnswerIndex+1 < userAnswers.length){
                this.setState({ 
                    currentUserAnswerIndex:currentUserAnswerIndex+1,
                });
                if(!isEmpty(userAnswers)&&userAnswers[currentUserAnswerIndex+1].hasOwnProperty('geoLocation')){
                    this.setState({ gotAddress:false});
                    this.locationGet(Object.values(Object.values(userAnswers[currentUserAnswerIndex+1].geoLocation))[0],
                    Object.values(Object.values(userAnswers[currentUserAnswerIndex+1].geoLocation))[1]);
                    this.getLocation(Object.values(Object.values(userAnswers[currentUserAnswerIndex+1].geoLocation))[0],
                    Object.values(Object.values(userAnswers[currentUserAnswerIndex+1].geoLocation))[1]);
                }
            }

        }
        previousUserAnswer = () =>{
            const {currentUserAnswerIndex} = this.state
            const {userAnswers} = this.props;

            if(currentUserAnswerIndex-1 > -1){
                this.setState({
                    currentUserAnswerIndex:currentUserAnswerIndex-1,
               });
               if(!isEmpty(userAnswers)&&userAnswers[currentUserAnswerIndex-1].hasOwnProperty('geoLocation')){
               
                this.setState({ gotAddress:false});
                this.locationGet(Object.values(Object.values(userAnswers[currentUserAnswerIndex-1].geoLocation))[0],
                Object.values(Object.values(userAnswers[currentUserAnswerIndex-1].geoLocation))[1]);
                this.getLocation(Object.values(Object.values(userAnswers[currentUserAnswerIndex-1].geoLocation))[0],
                Object.values(Object.values(userAnswers[currentUserAnswerIndex-1].geoLocation))[1]);
                }
            }


        }

        locationGet = (lat,long) => {
          const {currentUserAnswerIndex} = this.state
          const {userAnswers} = this.props;
         
          fetch('https://nominatim.openstreetmap.org/reverse?format=json&lon=' + long + '&lat=' + lat).then((response)=>{
            var apple =  response.json();
          console.log("Respnd",  apple);
          return apple;
          }).then((json)=>{
            console.log("address formatted correctly", json.display_name);
            const address1 = json.display_name;
            this.setState({ address1:address1});
            this.setState({ gotAddress:true});
          },
          error => {
            this.setState({ address1:error.message});
            this.setState({ gotAddress:true});
            console.log("This is error", error.message)    
          }
          )  
        }

        getLocation = (lat,long) => {
            Geocode.fromLatLng(lat, long).then(
                response => {
                  const address = response.results[0].formatted_address;
                  this.setState({ address:address});
                
                  this.setState({ gotAddress:true});
                },
                error => {
                    this.setState({ address:error.message});
                    this.setState({ gotAddress:true});
                    console.log("This is error of origin", error.message)
                    
                }
              );
        }

        componentWillMount = () => {
            const {currentUserAnswerIndex} = this.state
            const {userAnswers} = this.props;
            if(!isEmpty(userAnswers)&&userAnswers[currentUserAnswerIndex].hasOwnProperty('geoLocation')){
                this.locationGet(Object.values(Object.values(userAnswers[currentUserAnswerIndex].geoLocation))[0],
                Object.values(Object.values(userAnswers[currentUserAnswerIndex].geoLocation))[1]);
                this.getLocation(Object.values(Object.values(userAnswers[currentUserAnswerIndex].geoLocation))[0],
                Object.values(Object.values(userAnswers[currentUserAnswerIndex].geoLocation))[1]);
                console.log("address please work",Object.values(Object.values(userAnswers[currentUserAnswerIndex].geoLocation))[0],this.state.address);
            }
          }

          getExportData = () => {

            const {responseValue,width,currentUserAnswerIndex,address} = this.state
            const {survey,classes,userAnswers,users} = this.props;

            var user = users[userAnswers[currentUserAnswerIndex].userID]
            var answers = Object.values(userAnswers[currentUserAnswerIndex].answers)
            var questions =  Object.values(Object.values(userAnswers&&userAnswers.length>0?userAnswers[currentUserAnswerIndex].questions:[]))
            var data = []

            for(var i = 0 ;i < answers.length;i++){
                console.log(answers[i],questions[i].prompt)
                    data.push(
                        {
                        name:i==0&&user&&user.name?user.name:"",
                        surname:i==0&&user&&user.surname?user.surname:"",
                        phoneNumber:i==0&&user&&user.phoneNumber?user.phoneNumber:"",
                        balance:i==0&&user&&user.balance?user.balance:"",
                        address:i==0&&this.state.address1!=="Failed to fetch"?this.state.address1:"", //Server returned status code OVER_QUERY_LIMIT
                        candidate:i==0?userAnswers[currentUserAnswerIndex].phoneNumber:"",
                        index:i+1,
                        question:questions[i].prompt,
                        answer:answers[i],
                        })
                }
                return data;
          }

          getAllExportData = () => {

            const {responseValue,width,address} = this.state
            const {survey,classes,userAnswers,users} = this.props;
            var data = []
            for(var currentUserAnswerIndex = 0 ;currentUserAnswerIndex < userAnswers.length ;currentUserAnswerIndex++){

                var user = users[userAnswers[currentUserAnswerIndex].userID]
                var answers = Object.values(userAnswers[currentUserAnswerIndex].answers)
                var questions = Object.values(Object.values(userAnswers&&userAnswers.length>0?userAnswers[currentUserAnswerIndex].questions:[]))
                for(var i = 0 ;i < answers.length;i++){
                        data.push(
                            {
                            name:i==0&&user&&user.name?user.name:"",
                            surname:i==0&&user&&user.surname?user.surname:"",
                            phoneNumber:i==0&&user&&user.phoneNumber?user.phoneNumber:"",
                            balance:i==0&&user&&user.balance?user.balance:"",
                            address:i==0&&this.state.address1!=="Failed to fetch"?this.state.address1:"",
                            candidate:i==0?userAnswers[currentUserAnswerIndex].phoneNumber:"",
                            index:i+1,
                            question:questions[i].prompt,
                            answer:answers[i],
                            })
                    }

            }

           return data;
        }

         answerList = () => {
            const {responseValue,width,currentUserAnswerIndex,address} = this.state
            const {survey,classes,userAnswers,users} = this.props;

            let user = "";
            var linkToMap = "";

            if(!isEmpty(userAnswers&&userAnswers[currentUserAnswerIndex].geoLocation)){
                user = users[userAnswers[currentUserAnswerIndex].userID]

                if(this.state.address1){
                    linkToMap = this.state.address1!=="Failed to fetch"?//"Server returned status code OVER_QUERY_LIMIT"
                    "http://maps.apple.com/?ll=["+Object.values(Object.values(userAnswers[currentUserAnswerIndex].geoLocation))[0]+"],["+Object.values(Object.values(userAnswers[currentUserAnswerIndex].geoLocation))[1]+"]z={zoom}&q={"+this.state.address1+"}"
                    :
                    "http://maps.apple.com/?ll=["+Object.values(Object.values(userAnswers[currentUserAnswerIndex].geoLocation))[0]+"],["+Object.values(Object.values(userAnswers[currentUserAnswerIndex].geoLocation))[1]+"]z={zoom}"
                }

            }

            let listItems = [];

            if(!isEmpty(userAnswers)&&userAnswers[currentUserAnswerIndex].hasOwnProperty('geoLocation')&&address==null){
                this.getLocation(Object.values(Object.values(userAnswers[currentUserAnswerIndex].geoLocation))[0],
                Object.values(Object.values(userAnswers[currentUserAnswerIndex].geoLocation))[1]);
                this.locationGet(Object.values(Object.values(userAnswers[currentUserAnswerIndex].geoLocation))[0],
                Object.values(Object.values(userAnswers[currentUserAnswerIndex].geoLocation))[1]);
            }

              listItems = Object.values(Object.values(userAnswers&&userAnswers.length>0?userAnswers[currentUserAnswerIndex].questions:[])).map((question,index) =>
              <ExpansionPanel className={classes.questionPanel}   key={index}>
                <ExpansionPanelSummary className={classes.questionPanelSummary} expandIcon={<ExpandMoreIcon />}>
                <h4 style={{color:"rgba(0, 0, 0, 0.54)",fontSize:14}}>Question {index+1} : {question.prompt} </h4> 
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                { question.type == "image" ?
                    <img style={{width:"40%",height:"40%"}} src={Object.values(Object.values(userAnswers[currentUserAnswerIndex].answers))[index]} width="50%" height="50%"></img>
                    :
                  <Typography style={{minWidth:width*0.5}}>
                    {Object.values(Object.values(userAnswers[currentUserAnswerIndex].answers))[index]}
                  </Typography>
                }
                </ExpansionPanelDetails>
              </ExpansionPanel>

            );
        


            return (
           
             <div style={{marginTop:20}}>
             {!isEmpty(userAnswers)?
             <div style={{flexDirection:"row",marginBottom:20}}>
             <div  style={{width:"100%",color:"#fc824e",fontSize:20,marginBottom:15,marginBottom:10}}>Agent Information</div>
                 <div><span style={{color:"rgba(0, 0, 0, 0.54)"}}>Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: &nbsp;</span>{user&&user.name?user.name:"No User found"} {user&&user.surname?user.surname:null}</div>
                 <div><span style={{color:"rgba(0, 0, 0, 0.54)"}}>Email &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: &nbsp;</span>{user&&user.email?user.email:null}</div>
                 <div><span style={{color:"rgba(0, 0, 0, 0.54)"}}>Phone Number : </span>{user&&user.phoneNumber?user.phoneNumber:null}</div>
                 <div><span style={{color:"rgba(0, 0, 0, 0.54)"}}>Balance &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: &nbsp;</span>R {user&&user.balance?user.balance:0}</div>
             </div>:<div/>}
             {!isEmpty(userAnswers)&&userAnswers[currentUserAnswerIndex].hasOwnProperty('geoLocation')?
                 this.state.gotAddress?
                 <div>
                <div style={{flexDirection:"row",marginBottom:10}}><span style={{color:"rgba(0, 0, 0, 0.54)"}}>Completed At : </span>{this.state.address1!=="Failed to fetch"?this.state.address1:"Location not available"}</div>
                    <Button style={{padding:10,marginRight:30,marginBottom:20,backgroundColor:"#fc824e"}} color="warning" onClick={ () =>{window.open(linkToMap)}}>Open In Map</Button>
                    <div style={{float:"right"}}>
                        <ExportButton 
                                data={this.getExportData}
                                candidate={"Candidate: "+userAnswers[currentUserAnswerIndex].phoneNumber}
                                surveyName={survey.name}
                                />
                    </div>
                </div>
                :              
                <LoadingSpinner size={20} thickness={4}></LoadingSpinner>
                :
                <div/>
            }
                <div style={{float:"right",flexDirection:"row"}}>
                    <NavigateBefore style={{color:"#fc824e"}}  onClick={this.previousUserAnswer}/>
                    <span >  <span style={{color:"rgba(0, 0, 0, 0.54)",position:"relative",top:-6,fontSize:18}}>{currentUserAnswerIndex+1}  of  {userAnswers?userAnswers.length:0}</span>  </span>
                    <NavigateNext  style={{color:"#fc824e"}}  onClick={this.nextUserAnswer}/>
                </div>
                {!isEmpty(userAnswers)?<div style={{flexDirection:"row",marginBottom:20}}><span style={{color:"#fc824e"}}>Candidate phone number : </span>{ Object.values(Object.values(userAnswers[currentUserAnswerIndex].phoneNumber))}</div>:<div/>}
                {listItems}
              </div>
              );
          }

        renderIndividualResponses = () => {

            const {responseValue,currentUserAnswerIndex} = this.state
            const {survey,classes,userAnswers} = this.props;

            return(
             <div>
                {this.answerList(currentUserAnswerIndex)}
              </div>
            )
        }

        renderQuestionType(question,key){

            let reactElement = null;
    
            const {questions} = this.props;
    
            switch(question.type){
    
                case "text":
                default:
    
                   reactElement =
                        <TextQuestion inputProps={
                            {
                                defaultValue: question.prompt,
                                onChange: (event)=>{
                                    let question = questions[key];
                                    question.prompt = event.target.value
                                    questions[key] =question
                                    this.setState({questions:questions})}
    
                            }}
                                      isShortAnswer={question.isShortAnswer}
                                      disabled={true}
    
                                      onTypeChange={ (typeChange)=>{
    
                                          let question = questions[key];
                                          question.isShortAnswer = typeChange;
                                          questions[key] = question
                                          this.setState({questions:questions})
                                      }}
    
                        />
    
                        break;
                        case "image":
                        reactElement =
                                <ImageQuestion inputProps={
                                    {
                                        defaultValue: question.prompt,
                                        onChange: (event)=>{
                                            let question = questions[key];
                                            question.prompt = event.target.value
                                            questions[key] =question
                                            this.setState({questions:questions})}
            
                                    }}
                                            isShortAnswer={question.isShortAnswer}
                                            disabled={true}
            
                                            onTypeChange={ (typeChange)=>{
            
                                                let question = questions[key];
                                                question.isShortAnswer = typeChange;
                                                questions[key] = question
                                                this.setState({questions:questions})
                                            }}
            
                                />
        
                    break;
                case "multiple":
                    reactElement= <MultipleChoiceQuestion
                                    disabled={true}
                                    key={key}
                                    prompt={question.prompt}
                                    options={question.options}
                                    onOptionAdd={()=>{
                                        questions[key].options?questions[key].options.push(""):questions[key].options=[""];
                                        this.setState({questions:questions})
                                    }}
    
                                    promptInputProps={{
                                        defaultValue:question.prompt,
                                        onChange:(event)=>{
                                            questions[key].prompt = event.target.value;
                                            this.setState({questions:questions})
                                        }
    
                                    }}
    
                                    onOptionValueChange={
                                        (event,index)=>{
                                            questions[key].options[index] = event.target.value;
                                            this.setState({questions:questions})
                                        }
                                    }
    
                                    onOptionDelete={(index)=>{
                                        questions[key].options.splice(index,1)
                                        this.setState({questions:questions})
                                    }
                                    }
                    />
    
                break;
                case "checkbox":
                reactElement= <CheckBoxChoiceQuestion
                                disabled={true}
                                key={key}
                                prompt={question.prompt}
                                options={question.options}
                                onOptionAdd={()=>{
                                    questions[key].options?questions[key].options.push(""):questions[key].options=[""];
                                    this.setState({questions:questions})
                                }}
    
                                promptInputProps={{
                                    defaultValue:question.prompt,
                                    onChange:(event)=>{
                                        questions[key].prompt = event.target.value;
                                        this.setState({questions:questions})
                                    }
    
                                }}
    
                                onOptionValueChange={
                                    (event,index)=>{
                                        questions[key].options[index] = event.target.value;
                                        this.setState({questions:questions})
                                    }
                                }
    
                                onOptionDelete={(index)=>{
                                    questions[key].options.splice(index,1)
                                    this.setState({questions:questions})
                                }
                                }
                />
    
            break;
            }
            return reactElement
        }

        renderQuestions = () => {

            const {classes,survey,questions} = this.props
            const {isSaving} = this.state
    
            let questionIndex=0;
        
            return(
    
                <div className={classes.root}>
                    {isLoaded(survey)?
                    <div>
                        <div style={{alignItems:"center",justifyContent:"center"}} className={classes.questionContainer}>
                            <div  className={classes.surveyHeaderBar}>
                                <h6 style={{width:"100%",color:"#fc824e",fontSize:25,margin:0,}}>{survey&&survey.name?survey.name:"Untitled Campaign"}</h6>
                            </div>

                          <CustomInput
                          disabled={true}
                            labelText="Campaign Description"
                            inputProps={{
                                defaultValue:survey&&survey.description,
                                'aria-label': 'Campaign Description',
                                onChange:(event)=>{
                                    let survey = this.state.survey
                                    survey.description= event.target.value
                                    this.setState({survey:survey})}
                            }}
    
                            formControlProps={{
                                fullWidth: true
                            }}
                        />
                            <CustomInput
                             disabled={true}
                                value={survey&&survey.reward?survey.reward:""}
                                labelText="Campaign Reward"
                                inputProps={{
                                    defaultValue:survey&&survey.reward?survey.reward:"",
                                    'aria-label': 'Campaign Rewards',
                                    startAdornment:<InputAdornment position="start">R</InputAdornment>,
                                    onChange:(event)=>{
                                        let survey = this.state.survey
                                        survey.reward= event.target.value
                                        this.setState({survey:survey})}
                                }}
    
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />

                            <CustomInput
                            disabled={true}
                            value={survey&&survey.allowSurveyCompletionTimes?survey.allowSurveyCompletionTimes:10}
                            labelText="Number of times the survey can be completed"
                            inputProps={{
                                defaultValue:survey&&survey.allowSurveyCompletionTimes?survey.allowSurveyCompletionTimes:10,
                                'aria-label': 'Campaign Rewards',
                                onChange:(event)=>{
                                    let survey = this.state.survey
                                    survey.allowSurveyCompletionTimes= event.target.value
                                    this.setState({survey:survey})}
                            }}

                            formControlProps={{
                                fullWidth: true
                            }}
                        />
    
                            <TextField
                                style={{marginTop:30}}
                                disabled={true}
                                id="date"
                                label="Campaign End Date"
                                type="date"
                                value={survey&&survey.expiryDate}
                                className={classes.textField}
                                onChange={(event)=>{
                                    let survey = this.state.survey
                                    survey.expiryDate= event.target.value
                                    this.setState({survey:survey})
    
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
    
                            <div style={{marginTop:40}} className={classes.questionSection}>
                                {isLoaded(questions)?
                                    _.map(questions, (question,key)=>{
                                    questionIndex++;
                                    return(
                                    question?
                                    <ExpansionPanel className={classes.questionPanel} key={key}>
                                    <ExpansionPanelSummary className={classes.questionPanelSummary} expandIcon={<ExpandMoreIcon />}>
                                    <h4 style={{color:"rgba(0, 0, 0, 0.54)",fontSize:14}}>Question {questionIndex}</h4>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                    <div style={{width:"100%"}} className={classes.questionPanelDetails}>
                                        <div className={classes.questionControls}>
                                            <div> 
                                                <div style={{color:"rgba(0, 0, 0, 0.54)"}}>Question Type</div>
                                                <div disabled={true} style={{color:"currentColor",fontSize:18,opacity:1}}>{question.type}</div>
                                            </div>
                                        </div>
                                        <div className={classes.questionContent}>
                                        {this.renderQuestionType(question,key)}
                                        </div>
                                    </div>
    
                                    </ExpansionPanelDetails>
                                    </ExpansionPanel> :<div/>  )
                                }):<LoadingSpinner/>
                                }
    
    
                            </div>
                        </div>
                    </div>:
                    <LoadingSpinner/>}
                </div>
            )
       
        }

        



}

const styles={
    lightTooltip: {
        background: "white",
        fontSize: 12,
        color:"rgba(0, 0, 0, 0.87)",
        boxShadow:"0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15)"
      },
    root: {
        backgroundColor: "#fff",
      },
    paperContainer:{
        width:"60%",
        minWidth:300
    },
    surveyHeaderBar:{
        display:"flex",
        flexDirection:"row",
        justifyContent:"space-between",
        alignItems:"center"
    },
    root:{
        display:"flex",
        justifyContent:"center",
        marginTop:20
    },
    questionPanelSummary:{
        margin:0,height: 60
      },
    surveyControls:{
        display:"flex",
        justifyContent:"flex-end",
        margin:10
    },
    surveyContainer:{
        margin:10
    },
    fab:{
        position: 'absolute',
        bottom: 50,
        right: 50
    }
}

export default compose(
    withStyles(styles)
)(ViewSurvey)


// WEBPACK FOOTER //
// ./src/views/Surveys/ViewSurvey.jsx